import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {  NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from './app.module';
import { NumberFormatPipe } from './pipes/shared/number-format.pipe';
import { ModalComponent } from './shared/components/modal/modal.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { ButtonComponent } from './shared/components/button/button.component';
import { HorizontalScrollComponent } from './shared/components/horizontal-scroll/horizontal-scroll.component';
import { TabComponent } from './shared/components/tabs/tab.component';
import { TabsComponent } from './shared/components/tabs/tabs.component';
import { AgresIconsComponent } from './shared/components/agres-icons/agres-icons.component';
import { InputComponent } from './shared/components/input/input.component';
import { AlertComponent } from './shared/components/alert/alert.component';
import { RecommendationMapUploadComponent } from './shared/components/forms/recommendation-map-upload/recommendation-map-upload';
import { MenuPwaComponent } from './shared/components/menu-pwa/menu-pwa.component';
import { OffcanvasComponent } from './shared/components/offcanvas/offcanvas.component';
import { AgresSpinnerCanvasComponent } from './shared/components/agres-spinner-canvas/agres-spinner-canvas.component';
import { PaginationComponent } from './shared/components/pagination/pagination.component';
import { CardComponent } from './shared/components/card/card.component';
import { CardPrototypeComponent } from './shared/components/card-prototype/card-prototype.component';
import { CardDashboardComponent } from './shared/components/cards/card-dashboard/card-dashboard.component';
import { LinkComponent } from './shared/components/link/link.component';
import { CookieConsentBannerComponent } from './shared/components/cookie-consent-banner/cookie-consent-banner.component';
import { MobileAppPromptComponent } from './shared/components/mobile-app-prompt/mobile-app-prompt.component';
import { RouterModule } from '@angular/router';
@NgModule({
  imports: [
    NgSelectModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    CookieConsentBannerComponent,
    MobileAppPromptComponent,
  ],
  declarations: [
    NumberFormatPipe,
    ModalComponent,
    BreadcrumbComponent,
    ButtonComponent,
    TabComponent,
    TabsComponent,
    HorizontalScrollComponent,
    AgresIconsComponent,
    InputComponent,
    AlertComponent,
    MenuPwaComponent,
    RecommendationMapUploadComponent,
    OffcanvasComponent,
    AgresSpinnerCanvasComponent,
    PaginationComponent,
    CardComponent,
    CardPrototypeComponent,
    CardDashboardComponent,
    LinkComponent,
  ],
  exports: [
    NumberFormatPipe,
    ModalComponent,
    BreadcrumbComponent,
    ButtonComponent,
    TabComponent,
    TabsComponent,
    HorizontalScrollComponent,
    AgresIconsComponent,
    InputComponent,
    AlertComponent,
    MenuPwaComponent,
    RecommendationMapUploadComponent,
    OffcanvasComponent,
    AgresSpinnerCanvasComponent,
    PaginationComponent,
    TranslateModule,
    CardComponent,
    CardPrototypeComponent,
    CardDashboardComponent,
    LinkComponent,
    CookieConsentBannerComponent,
    MobileAppPromptComponent,
  ],
})
export class AppSharedModule {

}
